import { FileSearch } from "lucide-react";

export default function AdminEsimOrderLogsPanel({ logs, loading, onRefresh, filter, onFilterChange }) {
  const colorFor = (o) => o === "success" ? "var(--zc-success)" : o === "failed" ? "var(--zc-danger,#dc2626)" : "var(--zc-warn,#f59e0b)";

  return (
    <div className="zc-card overflow-hidden mt-4" data-testid="admin-esim-order-logs">
      <div className="px-4 py-3 border-b border-[var(--zc-border)] flex items-center justify-between">
        <div className="flex items-center gap-2">
          <FileSearch size={14} className="text-[var(--zc-text-3)]" />
          <div className="eyebrow">Airalo order log</div>
        </div>
        <div className="flex items-center gap-2">
          <select value={filter} onChange={(e) => onFilterChange(e.target.value)} className="zc-input h-8 px-2 text-xs" data-testid="esim-logs-filter">
            <option value="">All outcomes</option>
            <option value="success">Success</option>
            <option value="failed">Failed</option>
          </select>
          <button onClick={onRefresh} className="px-3 h-8 zc-btn-ghost text-xs" data-testid="esim-logs-refresh">Refresh</button>
        </div>
      </div>
      {loading && <div className="px-6 py-6 text-center text-[var(--zc-text-3)] text-xs">Loading…</div>}
      {!loading && logs.length === 0 && <div className="px-6 py-10 text-center text-[var(--zc-text-3)] text-sm">No order attempts logged yet.</div>}
      {logs.map((l) => {
        const audit = l.audit || {};
        const err = l.error || audit.error || {};
        const summary = audit.order_summary || {};
        const ts = l.created_at ? new Date(l.created_at).toLocaleString() : "—";
        return (
          <div key={l.log_id} className="px-4 py-4 border-b border-[var(--zc-border)] last:border-0 text-sm" data-testid={`esim-log-${l.log_id}`}>
            <div className="flex flex-wrap items-center gap-2 justify-between">
              <div className="font-mono zc-meta">{l.log_id}</div>
              <span className="zc-badge" style={{ background: "var(--zc-bg-2)", color: colorFor(l.outcome) }}>
                {l.outcome}
              </span>
            </div>
            <div className="mt-2 text-xs text-[var(--zc-text-2)] space-y-1">
              <div><b>Booking:</b> <span className="font-mono">{l.booking_id}</span> · <b>User:</b> {l.user_id}</div>
              <div><b>When:</b> {ts}</div>
              <div>
                <b>Airalo env:</b> {audit.environment || "—"} · <b>API:</b> <span className="font-mono break-all">{audit.api_base_url || "—"}</span>
                {audit.client_id_hint && <> · <b>Client:</b> {audit.client_id_hint}</>}
              </div>
              {l.outcome === "success" && (
                <div>
                  <b>Order:</b> {l.airalo_order_id || summary.airalo_order_id || "—"}
                  {l.airalo_order_code || summary.airalo_order_code ? ` · code ${l.airalo_order_code || summary.airalo_order_code}` : ""}
                  {(l.iccid || summary.iccid) && <> · ICCID <span className="font-mono">{l.iccid || summary.iccid}</span></>}
                  {l.activation_id && <> · activation <span className="font-mono">{l.activation_id}</span></>}
                </div>
              )}
              {l.outcome === "failed" && (
                <div style={{ color: "var(--zc-danger,#dc2626)" }}>
                  <b>Error:</b> {err.type || "Error"} — {err.message || JSON.stringify(err)}
                  {err.http_status && <> · HTTP {err.http_status}</>}
                </div>
              )}
              {err.response_preview && (
                <pre className="text-2xs font-mono bg-[var(--zc-bg-2)] p-2 rounded max-h-32 overflow-auto whitespace-pre-wrap break-all border border-[var(--zc-border)] mt-2">
                  {err.response_preview}
                </pre>
              )}
              {Array.isArray(audit.steps) && audit.steps.length > 0 && (
                <details className="mt-2">
                  <summary className="cursor-pointer text-[var(--zc-text-3)]">Provisioning steps ({audit.steps.length})</summary>
                  <pre className="text-2xs font-mono bg-[var(--zc-bg-2)] p-2 rounded max-h-48 overflow-auto whitespace-pre-wrap break-all border border-[var(--zc-border)] mt-2">
                    {JSON.stringify(audit.steps, null, 2)}
                  </pre>
                </details>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
